"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginUrl = getLoginUrl;
function getLoginUrl(appName, baseUrl = '/platform') {
    let loginUrl = `${baseUrl}/api/v1/oauth2/authorize/juvare_${appName ?? window.appName}`;
    const localhost = getLocalhost();
    if (localhost) {
        loginUrl = 'http://' + localhost + ':8080' + loginUrl;
    }
    return loginUrl;
}
function getLocalhost() {
    const host = window.location.host;
    if (/localhost(:\d+)?/.test(host) || /127\.0\.0\.1(:\d+)?/.test(host) || /::1(:\d+)?/.test(host)) {
        const i = host.indexOf(':');
        return i === -1 ? host : host.substring(0, i);
    }
    return undefined;
}
